import {Flex} from 'exsportia-components'
import {FC, useCallback} from 'react'

import {AVATAR_EXAMPLE} from '../../constants/common'
import {Button} from '../../ui/components/button/button'
import {useLocale} from '../../utils/i18n'
import {useModalActions} from '../../utils/modals'
import {ExsportiaLogoWithText} from '../exsportia-logo/exsportia-logo-with-text'
import {UserExsportiaCardModal} from '../user-exsportia-card-modal/user-exsportia-card-modal'

export const ExsportiaAccInfo: FC = () => {
  const {openModal} = useModalActions()
  const {l} = useLocale()
  const handleOpenLearnMoreModal = useCallback(() => {
    openModal({
      footerConfig: {disabled: true},
      component: (
        <UserExsportiaCardModal
          name='Evan Benson'
          avatar={AVATAR_EXAMPLE}
          subText='EX12345678'
          withDescription={true}
          phone='+91**********'
          viewOnly={true}
        />
      ),
    })
  }, [openModal])

  return (
    <Flex
      gap='4px'
      alignItems='center'
      cursor='pointer'
      onClick={handleOpenLearnMoreModal}
    >
      <Button
        icon='info'
        type='icon'
        isRightIcon
      >
        <Flex pr='8px'>{l('learnMore', {caseAction: 'capitalize'})}</Flex>
      </Button>
    </Flex>
  )
}

export const SignModalTitleWithInfo: FC = () => {
  const {l} = useLocale()

  return (
    <Flex
      width='100%'
      justifyContent='space-between'
    >
      <ExsportiaLogoWithText text={l('account')} />
      <ExsportiaAccInfo />
    </Flex>
  )
}
